import { ApiRequestOptions } from '@api/core/ApiRequestOptions';
import { getRequestOptions } from '@api/core/utils';

import type { CacheRequestViewModel } from '../models/CacheRequestViewModel';
import type { EmptyResponseViewModel } from '../models/EmptyResponseViewModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class CachesService {
  /**
   * Get
   * Gets payment value by key
   * @returns CacheRequestViewModel Success
   * @throws ApiError
   */
  public static async getPaymentKey(
    {
      key,
    }: {
      key?: string;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<CacheRequestViewModel> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<CacheRequestViewModel>({
      method: 'GET',
      url: `/caches`,
      query: {
        ...(key ? { key: key } : {}),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }

  /**
   * Save Payment Token
   * Saves payment token to cache
   * @returns EmptyResponseViewModel Success
   * @throws ApiError
   */
  public static async savePaymentKey(
    {
      body,
    }: {
      body?: CacheRequestViewModel;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<EmptyResponseViewModel> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<EmptyResponseViewModel>({
      method: 'POST',
      url: `/caches`,
      body: body,
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }
}
